import CryptoJS from 'crypto-js'
import { cryptoKey, ivSet } from './config'

/**
 * @description 加密
 * @param {string}  word
 * @return: uni_pwd
 */
export const encrypt = (word) => {
  var key = CryptoJS.enc.Utf8.parse(cryptoKey)
  var iv = CryptoJS.enc.Utf8.parse(ivSet)
  var encrypted = CryptoJS.AES.encrypt(word, key,
    {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    })
  return encrypted.toString() // 返回的是base64格式的密文
}

/**
 * @description 解密
 * @param {string}  word
 * @return: pwd
 */
export const decrypt = (word) => {
  var key = CryptoJS.enc.Utf8.parse(cryptoKey)
  var iv = CryptoJS.enc.Utf8.parse(ivSet)
  var decrypted = CryptoJS.AES.decrypt(word, key,
    {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    })
  return decrypted.toString(CryptoJS.enc.Utf8)
}
